export const jobsList = [
    {
        type: 'job', // job or education
        area: 'it', // it or smth else
        startDate: '11/2023', // mm/yyyy
        endDate: '09/2024',
        position: 'Front End Developer',
        positionUA: 'Фронт Енд розробник',
        company: 'Insiders', // Freelance if empty
        companyUA: 'Insiders', // Freelance if empty
        place: 'Lviv, Ukraine | office / online', //country or city
        placeUA: 'Львів, Україна | офіс / онлайн', //country or city
        duties: [
            `In this company, I worked on numerous frontend projects utilizing a diverse stack of
                technologies, including React, Next.js, Vue.js, Razor Pages, Blazor, HTML, SCSS, CSS, JavaScript,
                TypeScript, Redux, Tailwind CSS, Material-UI, and Git. Here's a brief overview of some projects:`,
            `-  Chat application based on WebSocket technology and AI integration.`,
            `-  Website for analyzing the efficiency of oil processing.`,
            `-  Company portfolio website built with Next.js.`,
            `-  Admin dashboard for instructors and clients.`,
            `-  Business card website developed using HTML, SCSS, and JS.`,
            `-  Modal window for booking visitation dates, customized for specific clients (similar to
                Calendly).`,
            `-  Home application for the elderly.`,
            `-  Web application for Shopify integration.`,
            `In these projects, I was responsible for frontend development, both from scratch and by
                modifying existing codebases. I also handled backend integration, optimized sites for performance
                using Lighthouse, configured deployments on Netlify, performed migrations from Vue.js to Next.js,
                and collaborated closely with .NET developers on certain projects.`,
        ],
        dutiesUA: [
            `У цій компанії я працював над численними проектами фронтенду, використовуючи різноманітний стек технологій, включаючи React, Next.js, Vue.js, Razor Pages, Blazor, HTML, SCSS, CSS, JavaScript, TypeScript, Redux, Tailwind CSS, Material-UI і Git. Ось короткий огляд деяких проектів:`,

            `- Чат-додаток на базі технології WebSocket та інтеграція з штучним інтелектом.`,
            `- Веб-сайт для аналізу ефективності переробки нафти.`,
            `- Веб-сайт портфоліо компанії на Next.js.`,
            `- Панель адміністратора для інструкторів та клієнтів.`,
            `- Веб-сайт-візитка, розроблений за допомогою HTML, SCSS та JS.`,
            `- Модальне вікно для бронювання дати відвідування, налаштоване для конкретних клієнтів (схоже на Calendly).`,
            `- Додаток для дому для літніх людей.`,
            `- Веб-додаток для інтеграції з Shopify.`,

            `У цих проектах я був відповідальний за розробку фронтенду, як з нуля, так і редагування існуючих кодових баз. Я також займався інтеграцією бекенду, оптимізацією сайтів для підвищення продуктивності за допомогою Lighthouse, налаштуванням розгортання на Netlify, виконував міграції з Vue.js на Next.js та тісно співпрацював з розробниками .NET над деякими проектами.
`,
        ],
        usedTechnics: [
            'React',
            'Next.js',
            'JS',
            'TS',
            'SCSS',
            'Tailwind CSS',
            'HTML',
            'Redux',
            'MUI',
            'Bootstrap',
            'Git',
            'Figma',
        ],
        usedTechnicsUA: [
            'React',
            'Next.js',
            'JS',
            'TS',
            'SCSS',
            'Tailwind CSS',
            'HTML',
            'Redux',
            'MUI',
            'Bootstrap',
            'Git',
            'Figma',
        ],
    },
    {
        type: 'job', // job or education
        area: 'it', // it or smth else
        startDate: '09/2023', // mm/yyyy
        endDate: '10/2023',
        position: 'Web developer',
        positionUA: 'Веб розробник',
        company: 'Softpartners', // Freelance if empty
        companyUA: 'Softpartners', // Freelance if empty
        place: 'Lviv, Ukraine | online', //country or city
        placeUA: 'Львів, Україна | онлайн', //country or city
        duties: [
            `I was responsible for developing a specific section of the website, which included the creation
                    of a modal window allowing users to submit feedback through a form comprising three rating
                    options and a comment field. Additionally, I designed a page featuring five accordion elements,
                    each containing unique content. Based on the selected options within these accordions,
                    corresponding grants were dynamically loaded`,
        ],
        dutiesUA: [
            `Я був відповідальний за розробку конкретного розділу веб-сайту, що включало створення модального вікна, що дозволяло користувачам залишати відгуки через форму, що складалася з трьох варіантів оцінки та поля для коментарів. Крім того, я розробив сторінку з п'ятьма акордеонами, кожен з яких містив унікальний вміст. На основі обраних варіантів у цих акордеонах динамічно завантажувалися відповідні дані.`,
        ],
        usedTechnics: ['JS', 'Wordpress', 'HTML', 'SCSS'],
        usedTechnicsUA: ['JS', 'Wordpress', 'HTML', 'SCSS'],
    },
    {
        type: 'job', // job or education
        area: 'it', // it or smth else
        startDate: '03/2023', // mm/yyyy
        endDate: '04/2023',
        position: 'Web developer',
        positionUA: 'Веб розробник',
        company: 'Softpartners', // Freelance if empty
        companyUA: 'Softpartners', // Freelance if empty
        place: 'Lviv, Ukraine | online', //country or city
        placeUA: 'Львів, Україна | онлайн', //country or city
        duties: [
            'I made edits to a website that was built on the WordPress platform using an additional plugin Avada. Specifically, I added JavaScript to the existing code that modified the functionality of the menu, both for desktop and small screens. Additionally, there were some other JavaScript edits made to the existing website.',
        ],
        dutiesUA: [
            'Я робив правки на сайті, який було сформовано на платформі Wordpress за допомогою додаткового плагіна Avada. А конкретно в існуючий код дописував JavaScript, який змінював роботу меню, як для пк так і для малих екранів. Крім того були ще деякі JS правки по існуючому сайті.',
        ],
        usedTechnics: ['JS', 'Avada', 'Wordpress'],
        usedTechnicsUA: ['JS', 'Avada', 'Wordpress'],
    },
    {
        type: 'job', // job or education
        area: 'it', // it or smth else
        startDate: '09/2022', // mm/yyyy
        endDate: '01/2023',
        position: 'Front-end developer',
        positionUA: 'Фронт-енд розробник',
        company: 'Softpartners', // Freelance if empty
        companyUA: 'Softpartners', // Freelance if empty
        place: 'Lviv, Ukraine | online', //country or city
        placeUA: 'Львів, Україна | онлайн', //country or city
        duties: [
            'I developed a site with eleven pages using HTML, SCSS, JS and Gulp based on the design provided in Figma. I collaborated directly with the client.',
        ],
        dutiesUA: [
            'Я розробив сайт з одинадцятьма сторінками за допомогою HTML, SCSS, JS та Gulp, використовуючи макет, наданий в Figma. Я напряму співпрацював з клієнтом.',
        ],
        usedTechnics: [
            'moving gradient',
            'CSS animation',
            'slick slider',
            'sending email by php',
            'Google captcha',
            'email validation',
            'burger menu',
            'adaptive design',
        ],
        usedTechnicsUA: [
            'рухомий градієнт',
            'CSS анімація',
            'слайдер Slick',
            'відправка електронної пошти за допомогою PHP',
            'Google captcha',
            'перевірка валідності електронної пошти',
            'бургер-меню',
            'адаптивний дизайн',
        ],
    },
    // {
    //     type: 'job', // job or education
    //     area: 'sales', // it or smth else
    //     startDate: '01/2022', // mm/yyyy
    //     endDate: '04/2022',
    //     position: 'Managing Director',
    //     positionUA: 'Директор магазину',
    //     company: 'Gebr. Heinemann', // Freelance if empty
    //     companyUA: 'Gebr. Heinemann', // Freelance if empty
    //     place: 'Lviv, Ukraine', //country or city
    //     placeUA: 'Львів, Україна', //country or city
    //     duties: [
    //         'I was responsible for the overall performance of the store, including sales, customer satisfaction, and operational efficiency. I managed a team of employees and ensured compliance with regulations. Additionally, I monitored financial performance, analyzed sales data, and made informed decisions to maximize profits and achieve organizational objectives.',
    //     ],
    //     dutiesUA: [
    //         'Я був відповідальний за загальну продуктивність магазину, включаючи продажі, задоволеність клієнтів та ефективність операцій. Я керував командою працівників та забезпечував відповідність законодавства. Крім того, я відстежував фінансові показники, аналізував дані продажів та приймав обґрунтовані рішення для максимізації прибутку та досягнення цілей організації.',
    //     ],
    //     usedTechnics: [],
    //     usedTechnicsUA: [],
    // },
    // {
    //     type: 'job', // job or education
    //     area: 'sales', // it or smth else
    //     startDate: '07/2019', // mm/yyyy
    //     endDate: '12/2021',
    //     position: 'Deputy Manager',
    //     positionUA: 'Заступник керівника магазину',
    //     company: 'Baltona', // Freelance if empty
    //     companyUA: 'Baltona', // Freelance if empty
    //     place: 'Lviv, Ukraine', //country or city
    //     placeUA: 'Львів, Україна', //country or city
    //     duties: [
    //         'I supervised staff activities, ensured customer satisfaction, and managed inventory control. In addition, I developed applications based on Microsoft Excel to enhance operational efficiency and streamline inventory management processes.',
    //     ],
    //     dutiesUA: [
    //         'Я наглядав за діяльністю персоналу, забезпечував задоволеність клієнтів та керував контролем за запасами. Крім того, я розробляв застосунки на основі Microsoft Excel з метою підвищення ефективності операцій та оптимізації процесів управління запасами.',
    //     ],
    //     usedTechnics: [],
    //     usedTechnicsUA: [],
    // },
    // {
    //     type: 'job', // job or education
    //     area: 'sales', // it or smth else
    //     startDate: '04/2013', // mm/yyyy
    //     endDate: '06/2018',
    //     position: 'Shift Manager',
    //     positionUA: 'Менеджер зміни',
    //     company: 'Baltona', // Freelance if empty
    //     companyUA: 'Baltona', // Freelance if empty
    //     place: 'Lviv, Ukraine', //country or city
    //     placeUA: 'Львів, Україна', //country or city
    //     duties: [
    //         'I oversaw daily operations, supervised staff, ensured efficient workflow, provided excellent customer service, and managed inventory control.',
    //     ],
    //     dutiesUA: [
    //         'Я керував щоденними операціями, контролював персонал, забезпечував ефективний робочий процес, надавав відмінний сервіс для клієнтів та здійснював управління контролем за запасами.',
    //     ],
    //     usedTechnics: [],
    //     usedTechnicsUA: [],
    // },
    // {
    //     type: 'job', // job or education
    //     area: 'sales', // it or smth else
    //     startDate: '07/2012', // mm/yyyy
    //     endDate: '03/2013',
    //     position: 'Sales Assistant',
    //     positionUA: 'Продавець-консультант',
    //     company: 'Baltona', // Freelance if empty
    //     companyUA: 'Baltona', // Freelance if empty
    //     place: 'Lviv, Ukraine', //country or city
    //     placeUA: 'Львів, Україна', //country or city
    //     duties: [
    //         'Main responsibilities included helping customers find and purchase products, handling transactions with accuracy, providing information about products, and keeping the store clean and organized.',
    //     ],
    //     dutiesUA: [
    //         "Основні обов'язки включають допомогу покупцям у знаходженні та придбанні товарів, обробку транзакцій, надання інформації про продукти та підтримку чистоти та порядку в магазині.",
    //     ],
    //     usedTechnics: [],
    //     usedTechnicsUA: [],
    // },
    // {
    //     type: 'job', // job or education
    //     area: 'assistant', // it or smth else
    //     startDate: '06/2012', // mm/yyyy
    //     endDate: '06/2012',
    //     position: 'Volunteer',
    //     positionUA: 'Волонтер',
    //     company: 'Lviv International Airport', // Freelance if empty
    //     companyUA: 'Міжнародний аеропорт Львів', // Freelance if empty
    //     place: 'Lviv, Ukraine', //country or city
    //     placeUA: 'Львів, Україна', //country or city
    //     duties: [
    //         'I assisted people with disabilities and helped The Aviation Security with huge passenger traffic.',
    //     ],
    //     dutiesUA: [
    //         'Я допомагав людям з інвалідністю, а також службі авіаційної безпеки при великому пасажиропотоці.',
    //     ],
    //     usedTechnics: [],
    //     usedTechnicsUA: [],
    // },
    // {
    //     type: 'job', // job or education
    //     area: 'services', // it or smth else
    //     startDate: '05/2010', // mm/yyyy
    //     endDate: '09/2010',
    //     position: 'Lifeguard',
    //     positionUA: 'Рятівник',
    //     company: "Big Kahuna's Water & Adventure Park", // Freelance if empty
    //     companyUA: 'Розважальний аквапарк Big Kahuna', // Freelance if empty
    //     place: 'Destin, FL', //country or city
    //     placeUA: 'Дестін, Флорида', //country or city
    //     duties: [
    //         'Ensured swimmer safety and responded promptly to emergencies as a Lifeguard.',
    //     ],
    //     dutiesUA: [
    //         'Забезпечував безпеку плавців та швидко реагував на надзвичайні ситуації в якості рятівника.',
    //     ],
    //     usedTechnics: [],
    //     usedTechnicsUA: [],
    // },
];
